//order, international tabs
export const getStatusClass = (status) => {
  if (["CANCELLED", "FAILED"].includes(status)) {
    return `bg-[#FEE2E2] text-[#991B1B] px-6 py-1 rounded-xl text-xs font-medium text-center `;
  } else if (status === "PENDING") {
    return "bg-yellow-100 text-[#92400E] px-5 py-1 rounded-xl text-xs font-medium text-center";
  } else if (["COMPLETED", "SUCCESS"].includes(status)) {
    return "bg-[#D1FAE5] text-[#065F46] px-4 py-1 rounded-xl text-xs font-medium text-center";
  } else {
    return "bg-[#E0E7FF] text-[#3730A3] px-3 py-1 rounded-xl text-xs font-medium text-center ";
  }
};
